/** @jsx jsx */

import React, { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import EditableBtn from '../EditableBtn';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getBlockById from 'services/apiHelpers/getBlockById';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { State } from 'store/store';
import { Block } from 'factories/block';
import { useSelector, useDispatch } from 'react-redux';
import { updateAssessmentAction } from 'actions/updateAssessmentAction';
import { findByKeyVal_V2 } from 'services/findByKeyVal';

const RetryAssessment = ({ children, ...props }) => {
  const context = useContext(interactionContext) as any;
  const { enableRetryAssessmentBtn } = context;
  const { enabled, visible } = enableRetryAssessmentBtn;

  const assessment = getCurrentTopic() as Block;
  const { props: assessmentProps } = assessment || {};

  const {
    SUBMIT = 'Submit',
    CONTINUE = 'Continue',
  } = assessmentProps as typeof assessmentProps & {
    assessmentQuestionSubmitLabel?: string;
    assessmentQuestionContinueLabel?: string;
  };

  const assessmentData = useSelector((state: State) => {
    return state.assessments[assessment.id];
    //
  });

  const dispatch = useDispatch();

  const interaction = getInteractionsInTopic(assessment)[0];
  const location = `${assessment?.props?.sId}/${interaction?.props?.sId}`;

  if (window.dev && window.dev()) {
    return enabled ? <EditableBtn {...props} /> : null;
  }

  return visible ? (
    <span
      style={{
        margin: '5px 10px',
      }}
      onClick={() => {
        const results = Object.keys(assessmentData.results);

        results.forEach((key: any) => {
          const { correctAnswer, attemptCount } = assessmentData.results[
            key
          ] as any;

          requestAnimationFrame(() => {
            dispatch(
              updateAssessmentAction({
                assessmentId: assessment.id,
                assessmentData: {
                  ...assessmentData.data,
                },
                questionData: {
                  [key]: {
                    answer: [],
                    correctAnswer,
                    isCorrect: undefined,
                    attemptCount,
                    submitButtonLabel: SUBMIT,
                    //: 'Submit',
                    navigateToResults: false,
                    isLocked: false,
                  },
                },
              })
            );

            //
          });
        });

        // if locationIsNull
        // then somehow the SId has not been created on the assessment/interaction block props
        const locationIsNull = location.includes('null');
        //
        if (locationIsNull) {
          window.location.href = `#i${interaction.id}`;
          return;
        }
        window.location.hash = location;
        //
      }}
    >
      <EditableBtn {...props} />{' '}
    </span>
  ) : null;
};

export default RetryAssessment;
